module.exports = __webpack_public_path__ + "img/market_comparison.8caf94a4.png";